import { render, staticRenderFns } from "./SelectedQuestionInfo.vue?vue&type=template&id=a3250350&"
import script from "./SelectedQuestionInfo.vue?vue&type=script&lang=js&"
export * from "./SelectedQuestionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports